
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.545 13.545c-1.818 0-3.363-.636-4.636-1.909C.636 10.364 0 8.818 0 7s.636-3.364 1.91-4.636C3.181 1.09 4.726.454 6.544.454c1.473 0 2.76.414 3.86 1.241 1.1.828 1.868 1.869 2.304 3.123h9.11c.6 0 1.113.214 1.54.641C23.786 5.886 24 6.4 24 7c0 .655-.227 1.182-.682 1.582-.454.4-.954.6-1.5.6v2.182c0 .6-.213 1.113-.64 1.54a2.1 2.1 0 01-1.542.641 2.1 2.1 0 01-1.54-.64 2.1 2.1 0 01-.642-1.541V9.182H12.71c-.436 1.254-1.204 2.295-2.304 3.123-1.1.827-2.387 1.24-3.86 1.24zm0-4.363a2.1 2.1 0 001.541-.641A2.1 2.1 0 008.727 7a2.1 2.1 0 00-.64-1.54 2.1 2.1 0 00-1.542-.642 2.1 2.1 0 00-1.54.641A2.1 2.1 0 004.364 7c0 .6.213 1.114.64 1.54a2.1 2.1 0 001.541.642z","fill":"#fff"}})])
          )
        }
      }
    